import { allThemes, AvailableThemes } from '../themes';
import { IThemeDef } from '../types';

export function getThemeDef(themeName: AvailableThemes = 'light'): IThemeDef {
  return allThemes[themeName];
}
